import JSZip from "jszip";
import { generatePackingListPdf } from "./PackingListPDF";
import { TPackingListPdfData } from "../../types/shipment.type"; 

export const createPackingListZip = async (packingListData: TPackingListPdfData[]): Promise<void> => {
  const zip = new JSZip();

  for (const packingListItem of packingListData) {
    const pdfBlob = await generatePackingListPdf(packingListItem);
    zip.file(`PackingList_${packingListItem.shipment_id}.pdf`, pdfBlob);
  }

  const zipBlob = await zip.generateAsync({ type: "blob" });
  const url = URL.createObjectURL(zipBlob);
  const link = document.createElement("a");
  link.href = url;
  link.download = "PackingLists.zip";
  link.click();
};
